import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import {
  DatePicker,
  DefaultButton,
  DefaultPrimaryButton,
  RadioButton,
  SelectWithLabel,
} from "../../../components/micro/input";
import ReactDatePicker from "react-datepicker";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getOutlet } from "../../../redux/companies/slice";
import {
  createSchedule,
  getServiceSchedulingList,
  getTechnicianList,
} from "../../../redux/service/slice";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { InputError } from "../../../components/error/error";
import RippleLoader from "../../../components/loader/RippleLoader";
import moment from "moment";

const ServicingModal = ({ onClose, appointmentStatus, data, modalMode }) => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [manualArrangements, setManualArrangements] = useState(false);
  const [activeTabs, setActiveTabs] = useState("One-Time Request");

  // Selector
  const { outletList, techniciansList, getSchedulingListData } = useSelector(
    (store) => ({
      outletList: store?.companiesData?.getOutletStatus?.data?.data,
      techniciansList: store?.technicianData?.getTechnicianListStatus?.data,
      getSchedulingListData:
        store?.serviceData?.getServiceSchedulingListStatus?.data?.data,
    })
  );

  // outlet and technician api call
  useEffect(() => {
    dispatch(
      getOutlet({
        search: "",
        pageLimit: "all",
        company_id: "",
        sort_by: "name",
        sort_direction: "asc",
      })
    );
    dispatch(
      getTechnicianList({
        pageLimit: "all",
      })
    );
    dispatch(
      getServiceSchedulingList({
        search: "",
        pageCount: 1,
        pageLimit: "",
        sort_by: "",
        technician: "",
        sort_direction: "desc",
        status: "all",
        recurring_status: "all",
        company: "",
        recurring_status_dropdown: "",
        service_request_type_id: activeTabs === "One-Time Request" ? 1 : 2,
      })
    );
  }, []);

  // Time Range
  const handleTimeRangeChange = () => {
    return [
      { value: "12:00AM_to_09:00AM", label: "12:00 AM to 09:00 AM" },
      { value: "09:00AM_to_12:00PM", label: "09:00 AM to  12:00 PM" },
      { value: "02:00PM_to_6:00PM", label: "02:00 PM to  06:00 PM" },
      { value: "06:00PM_to_10:00PM", label: "06:00 PM to  10:00 PM" },
      { value: "10:00PM_to_12:00AM", label: "10:00 PM to  12:00 AM" },
    ];
  };

  const outletOptions = (outletList?.data || outletList)?.map((outlet) => ({
    value: outlet?.id,
    label: outlet?.name,
  }));

  const techniciansOptions = (techniciansList?.data || techniciansList)?.map(
    (technicians) => ({
      value: technicians?.id,
      label: technicians?.full_name,
    })
  );

  const handleCancelClick = () => {
    setShowForm(true);
    onClose();
  };

  const handleConfirm = async (values, resetForm) => {
    setIsLoading(true);

    const payload = {
      id: data?.state?.schedule?.id ?? data?.id,
      service_appointment: values.manualArrangement ? 2 : 1,
      outlets:
        data?.outlet_id &&
        Array.isArray(data?.outlet_id) &&
        data?.outlet_id.length
          ? data?.outlet_id
          : Array.isArray(values?.outlet)
          ? values.outlet.map((outlet) => outlet.value)
          : values?.outlet
          ? [values?.outlet?.value]
          : [],
      technicians:
        data?.technician_id &&
        Array.isArray(data?.technician_id) &&
        data?.technician_id.length
          ? data?.technician_id
          : Array.isArray(values?.technician)
          ? values.technician.map((technician) => technician.value)
          : values?.technician
          ? [values?.technician?.value]
          : [],

      appointment_date: values?.appointmentDate
        ? dayjs(values.appointmentDate).format("DD/MM/YYYY")
        : null,

      appointment_time: values?.appointmentTime
        ? values?.appointmentTime?.value
        : null,
    };

    const action = createSchedule?.id
      ? createSchedule({ id: createSchedule.id, ...payload })
      : createSchedule(payload);

    try {
      const res = await dispatch(action);
      if (res.type === "createSchedule/fulfilled") {
        dispatch(
          getServiceSchedulingList({
            search: "",
            pageCount: 1,
            pageLimit: "",
            sort_by: "",
            technician: "",
            sort_direction: "desc",
            status: "all",
            recurring_status: "all",
            company: "",
            recurring_status_dropdown: "",
            service_request_type_id: 1,
          })
        );
        handleCancelClick();
        resetForm();
      }
    } catch (error) {
      console.error("Error while creating service:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {showForm && (
        <div className="model" style={{ zIndex: 1300 }}>
          <div className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg  max-w-xl min-h-40 py-8 px-20 mx-auto relative w-full ">
            {isLoading ? (
              <RippleLoader />
            ) : (
              <Formik
                enableReinitialize={true}
                initialValues={{
                  outlet:
                    appointmentStatus === "unscheduled" ||
                    modalMode === "unscheduled"
                      ? ""
                      : data?.outlet_id,
                  technician:
                    appointmentStatus === "unscheduled" ||
                    modalMode === "unscheduled"
                      ? ""
                      : data?.technician_id,
                  appointmentDate: "",
                  appointmentTime: "",
                  manualArrangement: false,
                }}
                validationSchema={Yup.object().shape({
                  outlet:
                    appointmentStatus === "scheduled" ||
                    modalMode === "scheduled"
                      ? Yup.array().nullable()
                      : Yup.object().nullable().required("Outlet is required"),
                  technician:
                    appointmentStatus === "scheduled" ||
                    modalMode === "scheduled"
                      ? Yup.array().nullable()
                      : Yup.object()
                          .nullable()
                          .required("Technician is required"),
                  appointmentDate:
                    appointmentStatus === "unscheduled" ||
                    modalMode === "unscheduled"
                      ? !manualArrangements
                        ? Yup.date().nullable()
                        : Yup.date()
                            .nullable()
                            .required("Appointment date is required")
                            .min(
                              new Date(),
                              "Appointment date cannot be in the past"
                            )
                      : Yup.date()
                          .nullable()
                          .required("Appointment date is required")
                          .min(
                            new Date(),
                            "Appointment date cannot be in the past"
                          ),
                  appointmentTime:
                    appointmentStatus === "unscheduled" ||
                    modalMode === "unscheduled"
                      ? !manualArrangements
                        ? Yup.date().nullable()
                        : Yup.object()
                            .nullable()
                            .required("Appointment time is required")
                      : Yup.object()
                          .nullable()
                          .required("Appointment time is required"),
                })}
                onSubmit={(values) => {
                  handleConfirm(values);
                }}
              >
                {({ values, errors, touched, setFieldValue, handleBlur }) => (
                  <Form>
                    {/* first modal */}
                    {appointmentStatus === "unscheduled" ||
                    modalMode === "unscheduled" ? (
                      <div className="w-full">
                        <h2 className=" font-Montserrat mb-3 text-center font-medium text-xl text-mgrey">
                          {appointmentStatus === "unscheduled"
                            ? "Scheduling"
                            : "Create a new servicing"}
                        </h2>
                        <div className="pt-5 w-96">
                          <SelectWithLabel
                            idFromName="outlet"
                            placeholder="Outlet"
                            options={outletOptions}
                            value={values?.outlet?.value}
                            setFieldValue={setFieldValue}
                            errors={errors.outlet}
                            touched={touched.outlet}
                            onChange={(event) => {
                              const selectedOption = outletOptions.find(
                                (option) => option.value === event.target.value
                              );
                              setFieldValue("outlet", selectedOption);
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  zIndex: 1301,
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                },
                              },
                            }}
                          />
                        </div>
                        <div className="my-4">
                          <SelectWithLabel
                            idFromName="technician"
                            placeholder="Technician"
                            options={techniciansOptions}
                            value={values?.technician?.value}
                            setFieldValue={setFieldValue}
                            errors={errors.technician}
                            touched={touched.technician}
                            onChange={(event) => {
                              const selectedOption = techniciansOptions.find(
                                (option) => option.value === event.target.value
                              );
                              setFieldValue("technician", selectedOption);
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  zIndex: 1301,
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                },
                              },
                            }}
                          />
                        </div>
                        {/* radio */}
                        <div className="mb-4 flex flex-col gap-2">
                          <div className="flex items-center">
                            <RadioButton
                              type="radio"
                              name="manualArrangement"
                              value="false"
                              checked={values.manualArrangement === false}
                              className="text-base text-left font-normal font-Proxima"
                              onChange={() => {
                                setFieldValue("manualArrangement", false);
                                setManualArrangements(false);
                              }}
                              onBlur={handleBlur}
                            />
                            <label>Push to Technician Listing</label>
                          </div>
                          <div className="flex items-center">
                            <RadioButton
                              type="radio"
                              name="manualArrangement"
                              value="true"
                              checked={values.manualArrangement === true}
                              onChange={() => {
                                setFieldValue("manualArrangement", true);
                                setManualArrangements(true);
                              }}
                              onBlur={handleBlur}
                              className="text-base font-normal font-Proxima"
                            />
                            <label>Manual Arrangement</label>
                          </div>
                        </div>
                        {values.manualArrangement && (
                          <>
                            <div>
                              <div>
                                <DatePicker
                                  id="appointmentDate"
                                  value={
                                    values.appointmentDate
                                      ? moment(values.appointmentDate)
                                      : null
                                  }
                                  onChange={(date) =>
                                    setFieldValue(
                                      "appointmentDate",
                                      date ? date.toDate() : null
                                    )
                                  }
                                  format="DD/MM/YYYY"
                                  icon={null}
                                />
                              </div>
                              {errors.appointmentDate &&
                              touched.appointmentDate ? (
                                <InputError
                                  errorTitle={errors.appointmentDate}
                                />
                              ) : null}
                            </div>
                            <div className="my-4">
                              <SelectWithLabel
                                idFromName="appointmentTime"
                                placeholder="Appointment Time"
                                options={handleTimeRangeChange()}
                                value={values?.appointmentTime?.value}
                                setFieldValue={setFieldValue}
                                errors={errors.appointmentTime}
                                touched={touched.appointmentTime}
                                onChange={(event) => {
                                  const selectedOption =
                                    handleTimeRangeChange()?.find(
                                      (option) =>
                                        option.value === event.target.value
                                    );
                                  setFieldValue(
                                    "appointmentTime",
                                    selectedOption
                                  );
                                }}
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      zIndex: 1301,
                                      maxHeight: "300px",
                                      overflowY: "auto",
                                    },
                                  },
                                }}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="w-full">
                        <h2 className=" font-Montserrat mb-3 text-center font-medium text-xl text-mgrey">
                          ReSchedule service appointment
                        </h2>
                        <div className="font-Proxima text-base font-normal text-textSecondary">
                          <p>Outlet:{data?.outlet || data?.upcomingServices}</p>
                          <p>Original Date: {data?.date}</p>
                          <p>Original Time Range: {data?.time_range}</p>
                        </div>
                        <div className="mt-4">
                          <div>
                            <DatePicker
                              id="appointmentDate"
                              value={
                                values.appointmentDate
                                  ? moment(values.appointmentDate)
                                  : null
                              }
                              onChange={(date) =>
                                setFieldValue(
                                  "appointmentDate",
                                  date ? date.toDate() : null
                                )
                              }
                              format="DD/MM/YYYY"
                              icon={null}
                            />
                          </div>
                          {errors.appointmentDate && touched.appointmentDate ? (
                            <InputError errorTitle={errors.appointmentDate} />
                          ) : null}
                          <div className="my-4">
                            <SelectWithLabel
                              idFromName="appointmentTime"
                              placeholder="New Time"
                              options={handleTimeRangeChange()}
                              value={values?.appointmentTime?.value}
                              setFieldValue={setFieldValue}
                              errors={errors.appointmentTime}
                              touched={touched.appointmentTime}
                              onChange={(event) => {
                                const selectedOption =
                                  handleTimeRangeChange()?.find(
                                    (option) =>
                                      option.value === event.target.value
                                  );
                                setFieldValue(
                                  "appointmentTime",
                                  selectedOption
                                );
                              }}
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    zIndex: 1301,
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                  },
                                },
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="flex justify-center gap-3">
                      <DefaultPrimaryButton
                        value="Cancel"
                        onClick={handleCancelClick}
                      />
                      <DefaultButton type="submit" value="Confirm" />
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ServicingModal;
